export default class TypeDocumentResidency {
  id!: number
  document_type!: string
  isEdit!: boolean
}
